import React, { memo } from "react";
import { HalfCard } from "@swiggy-private/dls-web-core/dist/components/HalfCard";

import OrderPlacementContent from "./OrderPlacementContent";
import { IOrderPlacementConfirmationProps } from "./types";

const OrderPlacementConfirmation = memo(({ show }: IOrderPlacementConfirmationProps) => {
    return (
        <HalfCard
            isOpen={show}
            closeOnOverlayClick={false}
            hideCloseIcon={true}
            hasCustomPadding={true}
            positionFromBottom={0}
        >
            <OrderPlacementContent />
        </HalfCard>
    );
});

OrderPlacementConfirmation.displayName = "OrderPlacementConfirmation";

export default OrderPlacementConfirmation;
